const NotFound = () => {
  return (
    <>
      <p>404</p>
    </>
  );
};

export default NotFound;
